export default "__VITE_ASSET__B9lkji8n__"